package com.bikompanion.domain

sealed interface SubmitVoteResult {
    /** The vote reached the backend. */
    data object Recorded : SubmitVoteResult

    /**
     * The vote is held locally and will be sent on the next successful request.
     *
     * Distinct from [Recorded] because it is: the rider is offline, the vote is real, and the
     * score they are looking at will not move until it flushes.
     */
    data object Queued : SubmitVoteResult

    /** Same identity voted on this bike too recently; [retryAfterMs] is how much longer to wait. */
    data class InCooldown(
        val retryAfterMs: Long,
    ) : SubmitVoteResult

    /**
     * The backend refused the vote — a rules rejection, a malformed key, a signed-out identity.
     *
     * Retrying unchanged will not help, which is what separates this from [Queued]. The local
     * implementation this replaced swallowed write failures and reported success anyway; with a
     * real backend a failure means something and has to surface.
     */
    data class Failed(
        val reason: BikeVoteFailure,
    ) : SubmitVoteResult
}
